import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { LabOSAuth } from './lib/labos.tsx';
import { initTheme } from './lib/theme';

initTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LabOSAuth appId="story-engine-liquid-sim-wbdlab">
      <App />
    </LabOSAuth>
  </StrictMode>,
);
